<div class="role-edit">
  <div class="role-edit__content">
    <div class="role-edit__header">
      <div class="role-edit__heading">
        <h1 class="page-title">Edit Role</h1>
        @if (role) {
        <p class="page-subtitle">Manage permissions for {{ role.name }}.</p>
        }
      </div>
      <div class="role-edit__actions">
        <button class="role-edit__secondary-btn" type="button" (click)="goBack()">Back</button>
        <button class="role-edit__primary-btn" type="button" [disabled]="isSaving || !roleId" (click)="savePermissions()">
          {{ isSaving ? "Saving..." : "Save changes" }}
        </button>
      </div>
    </div>

    @if (errorMessage) {
    <div class="role-edit__error">{{ errorMessage }}</div>
    }

    <div class="role-edit__layout">
      <section class="role-edit__card role-edit__card--permissions">
        <div class="role-edit__section-header">
          <div>
            <h2 class="role-edit__section-title">Permissions</h2>
            <p class="role-edit__section-hint">Select the permissions that apply to this role.</p>
          </div>
          <div class="role-edit__header-actions">
            <button class="role-edit__module-btn" type="button" (click)="selectAllPermissions()">Select all</button>
            <button class="role-edit__module-btn" type="button" (click)="deselectAllPermissions()">Deselect all</button>
            <div class="role-edit__search">
              <input
                class="role-edit__search-input"
                type="text"
                [formControl]="permissionSearch"
                placeholder="Search by module, action, or description" />
            </div>
          </div>
        </div>

        @if (permissionState.loading()) {
        <div class="role-edit__loading">Loading permissions...</div>
        } @else { @if (permissionGroups.length === 0) {
        <div class="role-edit__empty">No permissions match your search.</div>
        } @else {
        <div class="role-edit__modules">
          @for (group of permissionGroups; track group.module) {
          <div class="role-edit__module">
            <div class="role-edit__module-header">
              <div class="role-edit__module-meta">
                <h3 class="role-edit__module-title">{{ snakeCaseToTitle(group.module) }}</h3>
                <span class="role-edit__module-count">{{ group.permissions.length }} permissions</span>
              </div>
              <button class="role-edit__module-btn" type="button" (click)="toggleModulePermissions(group.module)">
                {{ areAllModulePermissionsSelected(group.module) ? "Remove all" : "Select all" }}
              </button>
            </div>
            <div class="role-edit__permissions">
              @for (permission of group.permissions; track permission.id) {
              <label class="role-edit__permission">
                <input type="checkbox" [checked]="isPermissionSelected(permission.id)" (change)="togglePermission(permission.id)" />
                <span class="role-edit__permission-text">
                  <span class="role-edit__permission-action font-monaco">{{ snakeCaseToTitle(permission.action) }}</span>
                  <span class="role-edit__permission-desc"
                    >{{ permission.description || (permission.module + ":" + permission.action) }}</span
                  >
                </span>
              </label>
              }
            </div>
          </div>
          }
        </div>
        } }
      </section>

      <section class="role-edit__card role-edit__card--summary">
        <h2 class="role-edit__section-title">Role details</h2>
        <div class="role-edit__summary">
          <div class="role-edit__summary-row">
            <span class="role-edit__summary-label">Name</span>
            <span class="role-edit__summary-value">{{ role?.name || "-" }}</span>
          </div>
          <div class="role-edit__summary-row">
            <span class="role-edit__summary-label">Description</span>
            <span class="role-edit__summary-value">{{ role?.description || "-" }}</span>
          </div>
          <div class="role-edit__summary-row">
            <span class="role-edit__summary-label">System role</span>
            <span class="role-edit__summary-value">{{ role?.isSystem ? "Yes" : "No" }}</span>
          </div>
          <div class="role-edit__summary-row">
            <span class="role-edit__summary-label">Selected permissions</span>
            <span class="role-edit__summary-value">{{ selectedPermissionIds.size }}</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
